import { CircleCheck, Info, TriangleAlert } from "lucide-react";

import { Alert, AlertTitle } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

const MESSAGE_TYPES = {
  warning: { icon: Info, className: "tw:text-warning" },
  error: { icon: TriangleAlert, variant: "destructive" },
  info: { icon: Info },
  success: { icon: CircleCheck, className: "tw:text-success" },
};

export function MessageSnack({ message, messageType = "warning" }) {
  const { icon: Icon, variant, className } = MESSAGE_TYPES[messageType];

  return (
    <div className="tw:absolute tw:top-1/2 tw:left-1/2 tw:z-10 tw:-translate-x-1/2 tw:-translate-y-1/2">
      <Alert
        variant={variant}
        data-type={messageType}
        className={cn("tw:w-auto tw:shadow-md", className)}
      >
        <Icon />
        <AlertTitle>{message}</AlertTitle>
      </Alert>
    </div>
  );
}
